import { gql } from '@apollo/client'

export const getStudentInterventionQuery = gql`
  query GetStudentIntervention($student_id: ID!, $school_year_id: ID!) {
    getStudentIntervention(student_id: $student_id, school_year_id: $school_year_id) {
      intervention_status
    }
  }
`
